module.exports = __webpack_public_path__ + "img/trapezoid.73bccacf.svg";